import React, { memo } from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import Image from 'next/legacy/image'

import OnedayMainForm from '../OnedayMainForm'
import sx from './styles'

const OnedayMain = ({ onSuccess }) => {
  return (
    <Box
      component="section"
      sx={sx.heroSection}
      id="OnedayMain"
    >
      {/* Background Image */}
      <Box sx={sx.backgroundWrapper}>
        <Image
          src="/oneday_assets/oneday_images/mainimage.jpg"
          alt="OneDay Background"
          layout="fill"
          objectFit="cover"
          objectPosition="center"
          priority
        />
      </Box>
      <Box sx={sx.overlay} />

      {/* Content */}
      <Container
        maxWidth="xl"
        sx={sx.contentContainer}
      >
        <Grid
          container
          spacing={{ xs: 4, md: 6 }}
          alignItems="start"
        >

          {/* Columna Izquierda (Textos) */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                ...sx.leftColumn,
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <Box
                sx={{
                  ...sx.logoContainer,
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%',
                }}
              >
                <Box
                  sx={{ width: '100%', maxWidth: '200px' }}
                >
                  <Image
                    src="/oneday_assets/oneday_logos/oneday_logo_begativo.svg"
                    alt="OneDay by ClikAuto"
                    width={280}
                    height={80}
                    layout="responsive"
                    objectFit="contain"
                  />
                </Box>
              </Box>

              <Typography
                component="h1"
                variant="inherit"
                sx={sx.mainTitle}
              >
                RECIBE OFERTAS REALES POR TU AUTO EN SOLO 24 HORAS
              </Typography>

              <Typography
                component="h2"
                variant="inherit"
                sx={sx.subtitle}
              >
                Más de 370 compradores buscando autos como el tuyo
              </Typography>
            </Box>
          </Grid>

          {/* Columna Derecha (Formulario) */}
          <Grid
            size={{ xs: 12, md: 6 }}
            display="flex"
            justifyContent={{ xs: 'center', md: 'flex-end' }}
          >
            <Box sx={{ width: '100%', maxWidth: 550 }}>
              <OnedayMainForm onSuccess={onSuccess} />
            </Box>
          </Grid>

        </Grid>
      </Container>
    </Box>
  )
}

export default memo(OnedayMain)
